module.exports = __webpack_public_path__ + "img/assemblageGlas.a672efea.jpg";